export default __webpack_public_path__ + "static/media/Front-HA-Car-Display.13176507.jpg";